import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id F84F1E59-868C-42CE-80EA-159588E83462
 * name record
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/record.svg
 * tags
 * - Home Automation 
 */
export const RecordIcon = createSvgIcon(<><path d="M19,12C19,15.86 15.86,19 12,19C8.14,19 5,15.86 5,12C5,8.14 8.14,5 12,5C15.86,5 19,8.14 19,12Z" /></>, 'RecordIcon');
export default RecordIcon